export default [
  {
    // 文档中心页
    path: '/doc',
    name: 'doc',
    meta: {
      group: 'doc',
    },
    component: () => import(/* webpackChunkName: "Doc" */ '../views/doc')
  },
  {
    path: '/doc/:collection_id/:doc_id?',
    name: 'docCollection',
    meta: {
      group: 'doc',
    },
    component: () => import(/* webpackChunkName: "DocCollection" */ '../views/doc/collection')
  }
]
